import { type ServeType } from '../../types';

export enum ScheduledMealBatchAction {
  UPSERT = 'UPSERT',
  DELETE = 'DELETE',
}

export interface ScheduledMealBatchItemRequestDto {
  action: ScheduledMealBatchAction;
  id?: number | null;
  day: string; // ISO date format: YYYY-MM-DD
  mealCategoryId: number;
  mealId?: number | null;
  price: number;
  isException: boolean;
  extraMealItemId1?: number | null;
  extraMealItemId2?: number | null;
  extraMealItemServeType1?: ServeType | null;
  extraMealItemServeType2?: ServeType | null;
}
